import { NotificationServiceHandler } from './notifications.service.handler';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FieldItem } from 'src/app/models/common/field-item';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Injectable()
export class NotificationService extends NotificationServiceHandler {
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService);
  }
}
